module.exports = __webpack_public_path__ + "img/slide13.e72c0287.png";